import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { signOut } from "firebase/auth";
import { useDispatch, useSelector } from "react-redux";
import { auth } from "../firebase/firebase";
import { clearUser } from "../redux/auth/authActions";
import { Navbar as RBNavbar, Nav, Container, Button } from "react-bootstrap";

const Navbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const user = useSelector((state) => state.auth.currentUser);

  const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL?.toLowerCase();
  const ADMIN_NAME = process.env.REACT_APP_ADMIN_NAME;
  const isAdmin = user?.email?.toLowerCase() === ADMIN_EMAIL;

  const handleLogout = async () => {
    try {
      await signOut(auth);
      dispatch(clearUser());
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const handleMyApplication = () => navigate("/my-application");
  const handleUserTestimonials = () => navigate("/testimonials");
  const handleManageTestimonials = () => {
    if (isAdmin) navigate("/admin-testimonials");
  };

  const openCoverLetterModal = () => {
    navigate("/cover-letter");
  };

  const openResumeScoreModal = () => {
    navigate("/resume-score");
  };

  return (
    <RBNavbar
      expand="lg"
      bg="primary"
      variant="dark"
      style={{ borderRadius: "0 0 12px 12px" }}
    >
      <Container fluid className="align-items-start">
        <div className="d-flex justify-content-between align-items-center w-100">
          {user && (
            <RBNavbar.Brand className="d-flex align-items-center gap-2">
              {user.photoURL && (
                <img
                  src={user.photoURL}
                  alt="User"
                  style={{
                    width: 35,
                    height: 35,
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "2px solid #fff",
                  }}
                />
              )}
              {isAdmin
                ? `${ADMIN_NAME} (Admin)`
                : user.displayName || user.email}
            </RBNavbar.Brand>
          )}

          {/* 🔼 Hamburger Toggle Right Aligned for Mobile */}
          <div className="d-lg-none d-flex">
            <RBNavbar.Toggle aria-controls="responsive-navbar-nav" />
          </div>
        </div>

        <RBNavbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto d-flex align-items-center flex-nowrap gap-2 flex-wrap mt-2 mt-lg-0">
            {user && location.pathname === "/success-page" && (
              <>
                {/* ✅ Laptop View - Keep buttons inline */}
                <div className="d-none d-lg-flex align-items-center gap-2">
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={openCoverLetterModal}
                    className="text-nowrap d-flex align-items-center gap-2"
                  >
                    <span role="img" aria-label="doc">
                      📄
                    </span>{" "}
                    Download Cover Letter
                  </Button>
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={openResumeScoreModal}
                    className="text-nowrap d-flex align-items-center gap-2"
                  >
                    <span role="img" aria-label="score">
                      📊
                    </span>{" "}
                    Get Resume Score
                  </Button>
                </div>

                {/* ✅ Mobile View - Centered Buttons */}
                <div className="d-flex d-lg-none flex-column w-100 gap-2 mt-2">
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={openCoverLetterModal}
                    className="w-100 d-flex justify-content-center align-items-center gap-2"
                  >
                    <span role="img" aria-label="doc">
                      📄
                    </span>{" "}
                    Download Cover Letter
                  </Button>
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={openResumeScoreModal}
                    className="w-100 d-flex justify-content-center align-items-center gap-2"
                  >
                    <span role="img" aria-label="score">
                      📊
                    </span>{" "}
                    Get Resume Score
                  </Button>
                </div>
              </>
            )}

            {user &&
              (isAdmin ? (
                <>
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={handleManageTestimonials}
                    className="text-nowrap"
                  >
                    Manage Testimonials
                  </Button>
                  <Button
                    size="sm"
                    variant="light"
                    style={{ color: "red" }}
                    onClick={handleLogout}
                    className="text-nowrap"
                  >
                    Logout
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={handleUserTestimonials}
                    className="text-nowrap"
                  >
                    User Testimonials
                  </Button>
                  <Button
                    size="sm"
                    variant="warning"
                    onClick={handleMyApplication}
                    className="text-nowrap"
                  >
                    My Application
                  </Button>
                  <Button
                    size="sm"
                    variant="light"
                    style={{ color: "red" }}
                    onClick={handleLogout}
                    className="text-nowrap"
                  >
                    Logout
                  </Button>
                </>
              ))}
          </Nav>
        </RBNavbar.Collapse>
      </Container>
    </RBNavbar>
  );
};

export default Navbar;
